// extracted by mini-css-extract-plugin
export default {"GiftBox__container":"styles_GiftBox__container__RBSxK","GiftBox__imageContainer":"styles_GiftBox__imageContainer__hpp6r","GiftBox__image":"styles_GiftBox__image__FqqM9"};